import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import pinia from './store'

// 引入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// Fix mobile viewport height when virtual keyboard opens
function setFixedViewportHeight() {
  const initialHeight = window.innerHeight
  const setVar = (h) => {
    const vh = h * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }
  setVar(initialHeight)

  if (window.visualViewport) {
    // Only update for orientation/zoom changes; avoid reacting to keyboard height changes
    const onResize = () => {
      // Use the larger of initial and current to reduce jumps
      setVar(Math.max(initialHeight, window.visualViewport.height))
    }
    window.visualViewport.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', () => setTimeout(onResize, 300))
  } else {
    // Fallback
    window.addEventListener('orientationchange', () => setTimeout(() => setVar(window.innerHeight), 300))
  }
}

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用Pinia
app.use(pinia)
// 使用Router
app.use(router)
// 使用Element Plus
app.use(ElementPlus)

// Initialize viewport variable before mount
// setFixedViewportHeight()

app.mount('#app')
